export const GOOGLE_CLASSROOM_TILES = {
  'Students waiting for devices': 'Students waiting for devices',
};

export const GOOGLE_CLASSROOM_MIDLEVEL = {
  WAITING_FOR_DEVICES: 'WAITING_FOR_DEVICES',
};
